"use client";

import { useEffect } from "react";
import { useAuth } from "@/providers/auth-provider";

export default function LoginPage() {
  const { login, isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      login();
    }
  }, [loading, isAuthenticated, login]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#F7FAFC" }}>
      <div className="text-center">
        <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center mx-auto mb-4 animate-pulse">
          <span className="text-white text-xl font-bold">H</span>
        </div>
        <p className="text-gray-600">Redirecting to login...</p>
      </div>
    </div>
  );
}
